<template>
    <tailwind-layout title="One Time Passcode">
        <otp-form />
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import OtpForm from '@/Components/ExperianVerification/OtpForm.vue'

export default {
    components: {
        TailwindLayout,
        OtpForm,
    },
}
</script>
